/* eslint-disable react/prop-types */
/* eslint-disable react/sort-comp */
/* eslint-disable class-methods-use-this */
/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SpeedIcon from '@material-ui/icons/Speed';
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIcon from '@material-ui/icons/Assignment';
import BusinessIcon from '@material-ui/icons/Business';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import { connect } from 'react-redux';
import { urls, rolesType } from '../utils/constants';

const mapStateToProps = (state) => ({ roles: state.roles });

class ConnectedMainList extends Component {
  renderExamsMenuItem() {
    const { roles } = this.props;
    if (roles.includes(rolesType.admin) || roles.includes(rolesType.technician)) {
      return this.renderMenuItem(<AssignmentIcon />, 'Exames', urls.exams.path);
    }
    return null;
  }

  renderCompaniesMenuitem() {
    const { roles } = this.props;
    if (roles.includes(rolesType.admin) || roles.includes(rolesType.technician)) {
      return this.renderMenuItem(<BusinessIcon />, 'Empresas', urls.companies.path);
    }
    return null;
  }

  renderUsersMenuItem() {
    const { roles } = this.props;
    if (roles.includes(rolesType.admin) || roles.includes(rolesType.technician)) {
      return this.renderMenuItem(<PeopleIcon />, 'Usuários', urls.users.path);
    }
    return null;
  }

  renderDashboardMenuItem() {
    const { roles } = this.props;
    if (roles.includes(rolesType.admin) || roles.includes(rolesType.technician)) {
      return this.renderMenuItem(<SpeedIcon />, 'Dashboard', urls.dashboard.path);
    }
    return null;
  }

  renderImportMenuItem() {
    const { roles } = this.props;
    if (roles.includes(rolesType.admin) || roles.includes(rolesType.technician)) {
      return this.renderMenuItem(<ImportExportIcon />, 'Import', urls.import.path);
    }
    return null;
  }

  renderProfileMenuItem() {
    const { roles } = this.props;
    if (roles.includes(rolesType.admin) || roles.includes(rolesType.technician)) {
      return this.renderMenuItem(<AccountCircle />, 'Perfil', urls.profile.path);
    }
    return null;
  }

  render() {
    return (
      <div>
        {/* Exames */}
        {this.renderExamsMenuItem()}

        {/* Usuários */}
        {this.renderUsersMenuItem()}

        {/* Dashboard */}
        {this.renderDashboardMenuItem()}

        {this.renderImportMenuItem()}

        {this.renderCompaniesMenuitem()}

        {/* Perfil */}
        {this.renderProfileMenuItem()}
      </div>
    );
  }

  renderMenuItem(icon, label, href) {
    return (
      <ListItem component="a" href={href}>
        <ListItemIcon>
          {icon}
        </ListItemIcon>
        <ListItemText primary={label} />
      </ListItem>
    );
  }
}

const MainListItems = connect(mapStateToProps)(ConnectedMainList);
export default MainListItems;
